import React from 'react'

const AllEstimates = () => {
  return (
    <div>AllEstimates</div>
  )
}

export default AllEstimates